module.exports = __webpack_public_path__ + "img/titleImgPc.ef057911.png";